export { default } from "./HeroIphone";
export * from "./HeroIphone";
